// Inspired by: https://thoughtspile.github.io/2021/04/05/useref-usememo/

import { useRef } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DependencyList = ReadonlyArray<any> | { [key: string]: any }

export const useCustomMemo = <T, Deps extends DependencyList>(
  functionToMemoize: () => T,
  deps: Deps,
  comparator: (current: Deps, prev: Deps) => boolean
): T => {
  const memoizedValueRef = useRef<T>(functionToMemoize())
  const lastDepsRef = useRef<Deps>(deps)

  if (!comparator(deps, lastDepsRef.current)) {
    memoizedValueRef.current = functionToMemoize()
    lastDepsRef.current = deps
  }

  return memoizedValueRef.current
}
